<template>
  <Layout>
    <app-unidades-tabla />
  </Layout>
</template>

<script>
import UnidadesTabla from "../components/UnidadesTabla/UnidadesTabla.vue";

export default {
  components: {
    "app-unidades-tabla": UnidadesTabla
  }
};
</script>
